<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <div
    appPadding
    paddingL="0"
    class="scroll-wrapper ui basic segment"
    [ngClass]="{ loading: pending }"
  >
    <ng-template [ngIf]="!isUnit">
      <div class="ui form">
        <div class="grouped fields">
          <div
            class="field"
            *ngFor="let department of departments"
            appMargin
            marginY="5"
          >
            <div
              class="detail"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="5%">
                <sui-radio-button
                  name="org"
                  [value]="department.organizationId"
                  [(ngModel)]="organizationId"
                ></sui-radio-button>
              </div>
              <div fxFlex="grow">
                {{ department?.organizationShortName }}
              </div>
              <div fxFlex="45%">
                <sui-select
                  class="selection"
                  [options]="roles"
                  valueField="roleId"
                  labelField="roleName"
                  isSearchable="true"
                  [(ngModel)]="user.roleId.roleId"
                  placeholder="Search to select role"
                  #multiSelectsy
                >
                  <sui-select-option
                    *ngFor="let option of multiSelectsy.filteredOptions"
                    [value]="option"
                  >
                  </sui-select-option>
                </sui-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="isUnit">
      <div class="ui form">
        <div class="grouped fields">
          <div class="field" *ngFor="let department of units">
            <div
              class="detail"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="10%">
                <sui-radio-button
                  name="orgunit"
                  [value]="department.organizationUnitId"
                  [(ngModel)]="unitId"
                ></sui-radio-button>
              </div>
              <div fxFlex="grow">
                {{ department?.unitName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    *ngIf="!isUnit"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="submit()"
    autofocus
  >
    Update Department
  </button>
  <button
    class="ui primary button"
    *ngIf="isUnit"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="submitContinue()"
    autofocus
  >
    Update Unit
  </button>
</div>
